import * as React from 'react'
import { SalesCenterNotes } from './SalesCenterNotes'
import { ENTITY_TYPES } from '@sales-center/common'
import type { ILeadDetail } from '@user/store/lead'
import type { IOpportunityDetail } from '@user/store/opportunity'

import Box from '@mui/material/Box'
import {
  NotesButton,
  useNotesDrawer,
} from '@user/components/Leads/LeadCard/NotesDrawer'
import { AddNoteDrawer } from '@user/components/Notes'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { NoteFilters } from '@user/components/Notes/EntityNotes/NoteFilters'
import { useNoteFilterState } from '@user/components/Notes/EntityNotes/hooks/useNoteFilterState'
import { useLoadEntityLocationsOnMount } from '@user/store/entityLocations'
import { useTheme } from '@mui/material/styles'

type Props = {
  entityType: ENTITY_TYPES
  detail: ILeadDetail | IOpportunityDetail
  canUpdate: boolean
}

export function NoteTabs(props: Props) {
  const { entityType, detail, canUpdate } = props
  const { id } = detail
  const notesState = useNotesDrawer({ detailPage: true, canUpdate })
  const noteFilterState = useNoteFilterState()
  const locationsStatus = useLoadEntityLocationsOnMount(id, entityType)

  const theme = useTheme()

  return (
    <Box width="100%">
      <Box>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          width="100%"
          p={2}
          sx={{
            borderBottom: `1px solid ${theme.palette.divider}`,
          }}
        >
          <Typography variant="h6" color="#000">
            Notes
          </Typography>
          <NotesButton {...notesState} canUpdate={canUpdate} />
        </Stack>

        <Stack
          width="100%"
          pl={2}
          pt={0}
          pr={2}
          sx={{
            backgroundColor: theme.palette.background.default,
          }}
        >
          <NoteFilters
            externalLinkId={detail.externalLocationId}
            entityType={entityType}
            {...noteFilterState}
          />

          <Stack width="100%" maxHeight="950px" overflow="auto">
            <SalesCenterNotes
              canUpdate={canUpdate}
              entityType={entityType}
              showPestPacNote={noteFilterState.showPestPacNote}
              showKnockStatusNote={noteFilterState.showKnockStatusNote}
              sortBy={noteFilterState.sortBy}
              detail={detail}
              locationsStatus={locationsStatus}
            />
          </Stack>
        </Stack>
      </Box>
      <AddNoteDrawer
        entityType={entityType}
        entityId={detail.id}
        externalLocationId={detail.externalLocationId}
        open={notesState.notesDrawerOpen}
        onClose={notesState.onCloseNotesDrawer}
      />
    </Box>
  )
}
